const styles = {
  stageSelectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 40,
  },
  info: {
    container: {
      marginBottom: 30,
      padding: 2,
      textAlign: "center",
    },
    title: { color: "gray" },
  },
  pageTitle: {
    container: { paddingTop: 30, paddingBottom: 20 },
  },
  spinner: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
};

export default styles;
